/**
 * features/credit/useCreditNotes.ts
 */
import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '@/lib/firebase';
import { COLLECTIONS, type CreditNote } from '@/types';

export function useCreditNotes() {
  const [creditNotes, setCreditNotes] = useState<CreditNote[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const q = query(collection(db, COLLECTIONS.creditNotes), orderBy('createdAt', 'desc'));
    return onSnapshot(
      q,
      (snap) => {
        setCreditNotes(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<CreditNote, 'id'>) })));
        setLoading(false);
      },
      () => setLoading(false),
    );
  }, []);

  return { creditNotes, loading };
}
